module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.$route.path !== '/chat') ? _c('div', {
    staticClass: "header"
  }, [(_vm.$route.path === '/') ? _c('div', {
    staticStyle: {
      "width": "70px"
    }
  }) : _vm._e(), _vm._v(" "), (!(_vm.$route.path === '/' || _vm.$route.path === '/contact') || !(_vm.$route.query.gim == null)) ? _c('a', {
    staticClass: "go-back",
    attrs: {
      "href": "#",
      "onclick": "window.history.back();"
    }
  }, [_vm._m(0), _vm._v("\n      Geri Dön\n    ")]) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./assets/logo.png")
    }
  }), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), (_vm.$route.path === '/chat') ? _c('div', {
    staticClass: "header chat-header"
  }, [(_vm.$route.path === '/') ? _c('div', {
    staticStyle: {
      "width": "70px"
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.$route.path !== '/' && !(_vm.$route.query.gim == null))) ? _c('a', {
    staticClass: "go-back ",
    attrs: {
      "href": "#",
      "onclick": "window.history.back();"
    }
  }, [_vm._m(1), _vm._v("\n      Geri Dön\n    ")]) : _vm._e(), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "go-icon"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "go-icon"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-427a9fc7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 233
// module chunks = 1